import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Star } from "lucide-react";

const AdminReviews = () => {
  const [items, setItems] = useState([]);
  const [workers, setWorkers] = useState({});
  useEffect(() => {
    api.get("/admin/reviews").then((r) => setItems(r.data.items)).catch(() => {});
    api.get("/admin/workers").then((r) => {
      const m = {};
      r.data.items.forEach((w) => { m[w.id] = w; });
      setWorkers(m);
    }).catch(() => {});
  }, []);

  return (
    <div>
      <h1 className="font-heading text-3xl font-bold text-[#2D3748]">Reviews</h1>
      <p className="text-[#718096] mt-1">Customer feedback collected after each job.</p>
      <div className="mt-6 grid md:grid-cols-2 gap-4">
        {items.length === 0 && (
          <div className="bg-white border border-[#E2E8F0] rounded-2xl p-12 col-span-2 text-center text-[#718096]">No reviews yet.</div>
        )}
        {items.map((r) => {
          const w = workers[r.worker_id];
          return (
            <div key={r.id} className="bg-white border border-[#E2E8F0] rounded-2xl p-5" data-testid={`admin-review-${r.id}`}>
              <div className="flex items-center justify-between flex-wrap gap-2">
                <div>
                  <div className="font-heading font-semibold text-[#2D3748]">{r.customer_name}</div>
                  <div className="text-xs text-[#718096]">{w ? w.business_name : "—"}</div>
                </div>
                <div className="inline-flex items-center gap-0.5">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <Star key={s} className={`w-4 h-4 ${s <= r.stars ? "text-[#FFB400] fill-[#FFB400]" : "text-[#E2E8F0]"}`} />
                  ))}
                </div>
              </div>
              <p className="mt-3 text-[#2D3748] text-sm leading-relaxed">{r.text}</p>
              <div className="mt-3 text-xs text-[#718096]">{new Date(r.created_at).toLocaleDateString()}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AdminReviews;
